export default function Configure($stateProvider) {
	$stateProvider.state('stocks-configuration-produits', {
		parent: 'gestion',
		url: '/stocks-configuration-produits',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.STOCKS" | translate }}'
		}
	});

	$stateProvider.state('stocks-configuration-produits.list', {
		url: '/list',
		template: '<stocks-configuration-produits></stocks-configuration-produits>',
		rights: { domain: 'stockconfigcp', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS.BREADCRUMBS.STOCKS_CONFIGURATION_PRODUITS" | translate}}'
		},
		navigation: {
			menu: 'stocks_configuration',
			translate: 'STOCKS.BREADCRUMBS.STOCKS_CONFIGURATION_PRODUITS',
			order: 1
		},
		search: 'STOCKS.BREADCRUMBS.STOCKS_CONFIGURATION_PRODUITS'
	});
}

Configure.$inject = ['$stateProvider'];
